"use strict";
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["Production"] = "production";
  Environment2["Staging"] = "staging";
  Environment2["Development"] = "development";
  return Environment2;
})(Environment || {});
const environment = (hostname = window.location.hostname) => {
  switch (hostname) {
    case "www.hubtran.com":
    case "audit.triumphpay.com":
      return "production" /* Production */;
    case "audit-staging.tfin.teleport.sh":
      return "staging" /* Staging */;
    default:
      return "development" /* Development */;
  }
};
export { environment, Environment };
